<template>
  <div class="d-flex flex-column">
    <div class="d-flex mb-5">
      <v-text-field
        v-model="selected.name"
        label="Name"
        outlined
        dense
        class="mr-4"
        hide-details
      ></v-text-field>
      <v-text-field
        v-model="selected.short_name"
        label="Short name"
        outlined
        dense
        hide-details
      ></v-text-field>
    </div>
    <v-text-field
      v-model="selected.title"
      label="Job title"
      outlined
      dense
      hide-details
      class="mb-5"
    ></v-text-field>
    <v-select
      v-model="selected.seniority"
      :items="seniority_items"
      label="Seniority"
      dense
      outlined
    ></v-select>
    <div class="d-flex mb-5">
      <v-text-field
        v-model.number="selected.age"
        label="Age"
        outlined
        dense
        class="mr-4"
        type="number"
        hide-details
      ></v-text-field>
      <v-text-field
        v-model.number="selected.years_of_exp"
        label="Years of experience"
        outlined
        dense
        hide-details
        type="number"
      ></v-text-field>
    </div>

    <v-autocomplete
      v-model="selected.timezone"
      :items="timezones"
      label="Timezone"
      outlined
      dense
      hide-details
      class="mb-5"
    ></v-autocomplete>
    <div class="d-flex mb-5">
      <v-text-field
        v-model.number="selected.rate_fulltime"
        label="Rate full-time"
        outlined
        dense
        class="mr-4"
        hide-details
        type="number"
      ></v-text-field>
      <v-text-field
        v-model.number="selected.rate_parttime"
        label="Rate part-time"
        outlined
        dense
        hide-details
        type="number"
      ></v-text-field>
    </div>
    <v-text-field
      v-model="selected.email"
      label="Personal email"
      outlined
      dense
      class="mb-5"
      hide-details
      type="email"
    ></v-text-field>
    <v-text-field
      v-model="selected.billing_email"
      label="Billing email"
      outlined
      dense
      class="mb-5"
      hide-details
      type="email"
    ></v-text-field>
    <v-text-field
      v-model="selected.interview_link"
      label="Interview link"
      outlined
      dense
      class="mb-5"
      hide-details
    ></v-text-field>
    <v-text-field
      v-model="selected.consulting_agreement_link"
      label="Consulting agreement link"
      outlined
      dense
      hide-details
    ></v-text-field>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      timezones: require('@/assets/timezones').default,
      seniority_items: [ 'junior', 'strong junior', 'middle', 'strong middle', 'senior', 'expert' ],
    }
  },
  computed: {
    ...mapGetters({
      selected: 'devs/selected',
      mode: 'devs/mode',
      showModal: 'devs/showModal',
    }),
  },
}
</script>

<style>

</style>